exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Navigation{position:fixed;bottom:0}.Navigation,.Navigation:after{height:3.7rem;background-color:#282f39;left:0;right:0;z-index:1000}.Navigation:after{background-color:red;position:absolute;bottom:-5rem;content:\" \"}.Navigation .icon{position:absolute;top:50%;left:1.5rem;margin-top:-.25rem;width:.5rem;height:.5rem;border-radius:2rem;background-color:#bfb;background-color:#333;left:7.25rem}.Navigation .uil-pacman-css{width:30px;height:30px;position:absolute;left:1rem;top:50%;margin-top:-28px;display:none}.Navigation .title{color:#fff;font-size:1.2rem;font-family:Roboto,sans-serif;margin:1rem .75rem;padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/Navigation.scss
// module id = 233
// module chunks = 0